// extracted by mini-css-extract-plugin
export var searchHeader = "_8i-0";
export var searchHeaderDark = "_8i-1";